export const ONLY_DEVICE_CONNECTION = 'ONLY_DEVICE_CONNECTION';
export const DEVICE_PLUS_SERVICE_CONNECTION = 'DEVICE_PLUS_SERVICE_CONNECTION';
export const ONLY_SERVICE_CONNECTION = 'ONLY_SERVICE_CONNECTION';

export function getActiveNoConnectedFloorSensors(availableSafeFloors, listOfConnectedDevices) {
  let updatedDevicesOptions = [];
  if (availableSafeFloors === null){
    return updatedDevicesOptions;
  } 
  for (const el of availableSafeFloors){
    let found = false;
    for (const el2 of listOfConnectedDevices){
        if (el.value == el2['serial']){
          found = true;
          break;
        }
    }
    if (!found) {
      updatedDevicesOptions.push({'title': el.title, 'value': el.value})
    }
  }
  return updatedDevicesOptions
    
}

export function concatenateLists(installations, connectedAtDevice) {

    let ouputList = []
    let deviceFromInstallation = []
    let deviceFromSafeTechLiveData = []
    if (installations){
      let serialFromInstallationList = []
      for (const element of installations) {
         serialFromInstallationList.push(element['serial'])
         // service
         deviceFromInstallation.push({
            ...element, 
            'type': ONLY_SERVICE_CONNECTION
          })
      }

      for (const element2 of connectedAtDevice) {

        if (serialFromInstallationList.indexOf(element2['SN']) < 0){
          // only on device
          deviceFromSafeTechLiveData.push({'id': null, 'serial': element2['SN'], 'type': ONLY_DEVICE_CONNECTION })
        } else {
          // got already installation, so update to device+service
          for (const install of deviceFromInstallation) {
            install.type = DEVICE_PLUS_SERVICE_CONNECTION;
          }
        }
      }
    } else {
      for (const element2 of connectedAtDevice) {
        // only on device
        deviceFromSafeTechLiveData.push({
          'id': null, 
          'serial': element2['SN'], 
          'type': ONLY_DEVICE_CONNECTION
        })
      }
    }
    // 
    for (let a of deviceFromInstallation){
      ouputList.push(a)
    }

    for (let a of deviceFromSafeTechLiveData){
      ouputList.push(a)
    }

    return ouputList;
  }


// WEBPACK FOOTER //
// ./src/components/Popup/DevicePopups/utils.js